import { Component, DoCheck, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AuthService } from 'src/app/_services/auth.service';
import { CompanyService } from 'src/app/_services/company.service';
import { Company } from 'src/models/company.model';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { User } from 'src/models/user.model';

@Component({
  selector: 'create-user-popup',
  templateUrl: './create-user-popup.component.html',
  styles: [],
})
export class PopupCreateUserComponent implements OnInit, DoCheck {
  companies: Company[] = [];
  user: User = {
    id: null,
    idCompany: null,
    idRolUser: null,
    idStatus: null,
    companyNameUser: null,
    date: null,
    dateLastLogin: null,
    department: null,
    email: null,
    location: null,
    name: null,
    phone: null,
    userName: null,
  };
  departments: any;
  roles: any;
  isLoading: boolean = false;

  duplicateUserNameError = false;
  duplicateEmailError = false;
  canSave = false;

  protected ngbModalRef: NgbModalRef;
  private emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  private phoneRegex = /^\d{6,10}$/;

  constructor(
    public activeModal: NgbActiveModal,
    public companyService: CompanyService,
    public bsModalRef: BsModalRef,
    private authService: AuthService,
    public toastrService: ToastrService,
    public translateService: TranslateService
  ) {}

  ngOnInit() {
    this.companyService.getRoles().subscribe((res) => {
      this.roles = res.body;
    });
  }

  ngDoCheck(): void {
    this.canSave =
      this.user.name &&
      this.user.name !== '' &&
      this.user.userName &&
      this.user.userName !== '' &&
      this.user.email &&
      this.user.email !== '' &&
      this.emailRegex.test(this.user.email) &&
      this.user.phone &&
      this.phoneRegex.test(this.user.phone) &&
      this.user.idRolUser &&
      this.user.idCompany;
  }

  save() {
    this.isLoading = true;
    const entity = {
      ...this.user,
      roleId: this.user.idRolUser,
      companyId: this.user.idCompany,
      statusId: this.user.idStatus,
    };

    this.authService.register(entity).subscribe(
      (res) => {
        this.isLoading = false;
        this.toastrService.success(
          this.translateService.instant('alert.successCreate')
        );
        this.activeModal.close(entity);
      },
      (error) => {
        this.isLoading = false;
        this.toastrService.error(this.translateService.instant('alert.error'));

        if (error === 'duplicate userName') {
          this.duplicateUserNameError = true;
        }

        if (error === 'duplicate email') {
          this.duplicateEmailError = true;
        }
      }
    );
  }

  changeUserName() {
    this.duplicateUserNameError = false;
  }

  changeEmail() {
    this.duplicateEmailError = false;
  }

  companyChanged(event) {
    this.companyService.getDepartmentsByCompany(event).subscribe((res) => {
      this.departments = res.body.filter((n) => n);
    });
  }

  cancel() {
    this.activeModal.dismiss();
  }
}
